import LogisticsCompany from "@/enum/LogisticsCompany";
import { get, postJson } from "../http/backend";
import UserType from "@/enum/UserType";
import { SharedEwaybillQuantityChangeRecord } from "./sharedEwaybillShippingAddress";
import { SharedEwaybillAccount } from "./sharedEwaybillAccount";
import TaskStatusEnum from "@/enum/TaskStatusEnum";

export enum QuantityChangeOperationType {
  /**
   * 自动增加：对应系统自动回收的电子面单额度
   */
  AUTOMATIC_INCREASE = "AUTOMATIC_INCREASE",

  /**
   * 手动增加：对应管理员手动增加的电子面单额度
   */
  MANUAL_INCREASE = "MANUAL_INCREASE",

  /**
   * 手动减少：对应管理员手动减少的电子面单额度
   */
  MANUAL_DECREASE = "MANUAL_DECREASE",
}

export const QuantityChangeOperationTypeNameMapping = {
  [QuantityChangeOperationType.AUTOMATIC_INCREASE]: "自动增加",
  [QuantityChangeOperationType.MANUAL_INCREASE]: "手动增加",
  [QuantityChangeOperationType.MANUAL_DECREASE]: "手动减少",
};

interface GetRechargeRecordParams {
  /** 使用面单的人所属公司 ID，为空表示不限制。 */
  consumerCompanyId?: number;
  /** 共享面单的人所属公司 ID，为空表示不限制，userType 为 CONSUMER 时该字段必传。 */
  providerCompanyId?: number;
  /** 查询时间段截至日期（包含），格式：yyyy-MM-dd。 */
  endDate: string;
  /** 查询时间段开始日期（包含），格式：yyyy-MM-dd。 */
  startDate: string;
  /** 待查询的（非已共享）面单账号 ID，为空表示查询全部。 */
  ewaybillAccountId?: number;
  logisticsCompany?: LogisticsCompany;
  pageNo: number;
  pageSize: number;
  userType: UserType;
  needRecycleRecords?: boolean;
  operationType?: QuantityChangeOperationType;
}

interface OperatorUserInfo {
  id: number;
  nickName: string;
  remark: string;
}

interface RechargeRecords {
  content: SharedEwaybillQuantityChangeRecord[];
  pageNo: number;
  pageSize: number;
  totalElements: number;
  totalPages: number;
}

export interface RechargeRecordResult {
  operatorUserInfoList: OperatorUserInfo[];
  rechargeRecords: RechargeRecords;
  sharedEwaybillAccounts: SharedEwaybillAccount[];
  /** 增加单号次数 */
  increaseRechargeCount: number;
  /** 减少单号次数 */
  reduceRechargeCount: number;
  /** 总增加单号数量 */
  totalIncreaseQuantity: number;
  /** 总减少单号数量 */
  totalReduceQuantity: number;
}

/** 充值记录  */
export function getRechargeRecord(params: GetRechargeRecordParams) {
  return get<RechargeRecordResult>("/v2/shared_ewaybill_shipping_address/recharge_records", params);
}

interface ExportRechargeRecordResult {
  params: ExportRechargeRecordParams;
  status: TaskStatusEnum;
  downloadUrl: string;
  error?: string;
}

interface ExportRechargeRecordParams {
  listParams?: Partial<GetRechargeRecordParams>;
  taskId?: string;
}

/** 导出充值明细 */
export function exportRechargeRecord(params: ExportRechargeRecordParams) {
  return postJson<ExportRechargeRecordResult>("/v2/shared_ewaybill_shipping_address/recharge_records/export", params);
}
